import { Exit, Interactive, Player, Torch } from "../objects";
import levelDarkKit from "./levelDarkKit";
import { translate } from "../../utils/localization";

class Level18 extends levelDarkKit {
  constructor() {
    super();
    this.name = "The blind side";
    this.diamondsGoal = 10;
    this.quakePlayed = false;
  }

  get id() {
    return this.constructor.key;
  }

  onInteractWith(el) {
    super.onInteractWith(el);

    if (el.isClass(Exit)) {
      this.onComplete();
    }
    if (el.isClass(Interactive) && el.order === 0) {
      this.playDropTorchIncident(el);
    }
    // if (el.isClass(Interactive) && el.order === 1) {
    //   this.recoveryFromDropTorch()
    // }
  }

  async playDropTorchIncident(el) {
    this.player.disconnect();
    // breaks nothing
    await this.playEarthquake(
      {
        x1: el.position.x - 3,
        x2: el.position.x,
        y1: el.position.y - 3,
        y2: el.position.y,
      },
      4
    );
    await this.awaitTicks(2);
    if (this.unfinished) {
      this.displayIncidentDialog();
    }
    this.player.alien.setPipeline("Light2D");
    this.player.setOffTorch();
    this.scene.children.getByName("layer_0").resetPipeline("Light2D");
  }

  displayIncidentDialog() {
    this.scene.events.once("dialogue:hidden", () => {
      this.player.reconnect();
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary"],
      participantNames: ["Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_18.dialog_incident.mary_say_1")],
        },
      ],
    });
  }
  displayIncidentRecoveryDialog() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary"],
      participantNames: ["Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_18.dialog_incident_recovery.mary_say_1")],
        },
      ],
    });
  }

  recoveryFromDropTorch() {
    this.player.ligthTorch();
    this.player.alien.resetPipeline("Light2D");
    this.scene.children.getByName("layer_0").setPipeline("Light2D");
    if (this.unfinished) {
      this.displayIncidentRecoveryDialog();
    }
  }

  onAddElement(el) {
    super.onAddElement(el);

    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
      el.ligthTorch();
    }

    if (el.isClass(Torch) && el.order === 4) {
      el.ignite();
      el.proximityTrigger = () => {
        if (!this.player.torch) {
          this.recoveryFromDropTorch();
        }
      };
    }
  }
}

Level18.key = "level_18";
export default Level18;
